const model = {
    sizeDetails: null,
    loading: false,
    error: null,
};

export default model;
